import $ from "jquery";
import Tracker from "./../common/tracker";
import isEmpty from "../common/util";

const Api = (($) => {
  const Endpoint = "/_system/api/crm/forms";

  class Api {
    constructor() {}

    getForm(id) {
		return $.ajax({
			url: Endpoint + "/" + id,
			method: "GET",
			dataType: "json",
		});
    }

    submitForm(id, data, additionalHeaders = {}) {
      	let headers = { ...additionalHeaders },
			trackingCode = Tracker.getTrackingCode(),
			referrer = Tracker.getReferrer(),
			utmData = Tracker.getUTMCodes(),
			googleAdsClickID = Tracker.getGoogleAdsClickID();

		headers["X-ion-source-url"] = document.location.href;

		if (trackingCode) {
			headers["X-ion-tracking-code"] = trackingCode;
		}

		if (referrer) {
			headers["X-ion-referrer"] = referrer;
		}

	 	if (Object.keys(utmData).length > 0) {
			if (utmData.utmID) {
				headers["X-ion-utm-id"] = utmData.utmID;
			}
			if (utmData.utmSource) {
				headers["X-ion-utm-source"] = utmData.utmSource;
			}
			if (utmData.utmMedium) {
				headers["X-ion-utm-medium"] = utmData.utmMedium;
			}
			if (utmData.utmCampaign) {
				headers["X-ion-utm-campaign"] = utmData.utmCampaign;
			}
			if (utmData.utmTerm) {
				headers["X-ion-utm-term"] = utmData.utmTerm;
			}
			if (utmData.utmContent) {
				headers["X-ion-utm-content"] = utmData.utmContent;
			}
		}

      	if (googleAdsClickID) {
			headers["X-ion-gclid"] = googleAdsClickID;
		}

		return $.ajax({
			url: Endpoint + "/" + id,
			headers: headers,
			method: "POST",
			dataType: "json",
			data: data,
		});
    }
  }

  return new Api();
})($);

export default Api;
